import React, { FC } from "react";

type IProps = {
  color?: string;
};

const Menu: FC<IProps> = ({ color }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="3" width="20" height="2" rx="1" fill="#202124" />
      <rect y="9" width="20" height="2" rx="1" fill="#202124" />
      <rect y="15" width="20" height="2" rx="1" fill="#202124" />
    </svg>
  );
};

export default Menu;
